// Real Table of Contents — Self Doubling (First English edition, 2026)
// Extend this array as further chapters are provided.

export const TOC = [
  {
    big: "∞",
    tag: "Opening",
    title: "Front Matter",
    startPage: "2",
    items: [
      { t: "Editorial Data, Copyright and Deposits of the Work", p: "2" },
      { t: "Note on Terms and Intellectual Property", p: "4" },
      { t: "Acknowledgements", p: "5" },
      { t: "“The fundamental and important things in life can still be done” — M.G.M.", p: "5", indent: 1 },
      { t: "The Author", p: "6" },
      { t: "Introductory Note to Monica Zuretti’s Preface", p: "7" },
      { t: "Preface by Monica Zuretti", p: "9" },
    ],
  },
  {
    big: "00",
    tag: "Introduction",
    title: "Introduction",
    startPage: "25",
    items: [
      { t: "Dimensions of Time and Space: a neuro-psychodramatic exploration towards the Mosca Method and Self Doubling", p: "25" },
      { t: "The generative spirit of psychodrama and the birth of the Mosca Method", p: "28" },
    ],
  },
  {
    big: "01",
    tag: "Chapter 1",
    title: "Absorption and memory: neuroscientific and psychodramatic implications in human behaviour",
    startPage: "31",
    items: [
      { t: "1.1  Van der Kolk’s contribution to the neurobiology of trauma", p: "32" },
      { t: "1.2  Neuroimaging, Moreno, and Schützenberger", p: "34" },
      { t: "1.3  Moreno’s psychodrama and the theory of the encounter", p: "35" },
      { t: "1.4  Comparison and integration of the two approaches", p: "35" },
      { t: "1.5  Space, action, and bodily representation in memory", p: "38" },
      { t: "Bibliographical references for Chapter 1", p: "41", ref: true },
    ],
  },
  {
    big: "02",
    tag: "Chapter 2",
    title: "Flows of time: integrating Bergson, Heidegger, and Moreno in the understanding of Time",
    startPage: "43",
    items: [
      { t: "2.1  Duration and Being: the revolutionary concepts of Bergson and Heidegger", p: "46" },
      { t: "2.2  Moreno: affinities with Bergson", p: "48" },
      { t: "2.3  Moreno: affinities with Heidegger", p: "49" },
      { t: "2.4  Comparison and integration", p: "49" },
      { t: "2.5  Creative instability and the hunger for action", p: "50" },
      { t: "2.6  When the flow is interrupted: towards the duration of trauma", p: "51" },
      { t: "Bibliographical references for Chapter 2", p: "53", ref: true },
    ],
  },
  {
    big: "03",
    tag: "Chapter 3",
    title: "Traumatic duration in the Mosca Method: engrams, the missed response, and the transformation of unresolved suffering",
    startPage: "55",
    items: [
      { t: "3.1  Theoretical introduction: from philosophical temporality to traumatic duration", p: "55" },
      { t: "3.2  Trauma beyond the event", p: "56" },
      { t: "3.3  Unresolved suffering as duration", p: "57" },
      { t: "3.4  Engrams and implicit memory", p: "58" },
      { t: "3.5  The reactivatable trace and repetition", p: "59" },
      { t: "3.6  The missed response and the suspended space", p: "60" },
      { t: "3.7  Archiving and the Law of Temporo-Spatial Expansion", p: "61" },
      { t: "3.8  Body, posture, and somatic memory", p: "63" },
      { t: "3.9  Classical psychodrama and the Mosca Method", p: "64" },
      { t: "3.10  Self Doubling as living archiving", p: "65" },
      { t: "3.11  Intergenerational, transgenerational, and free/cosmic memory", p: "65" },
      { t: "3.12  Methodological originality and the status of traumatic duration", p: "67" },
      { t: "Bibliographical references for Chapter 3", p: "69", ref: true },
    ],
  },
  {
    big: "04",
    tag: "Chapter 4",
    title: "Sociometry: an exploration of the thought and method of Dr J. L. Moreno",
    startPage: "71",
    items: [
      { t: "4.1  The importance of sociometry in the therapeutic field", p: "76" },
      { t: "4.2  Moreno’s vision, the theory of relations, and the development of personality", p: "78" },
      { t: "4.3  Role theory and the development of personality", p: "81" },
      { t: "Bibliographical references for Chapter 4", p: "86", ref: true },
    ],
  },
  {
    big: "05",
    tag: "Chapter 5",
    title: "A. A. Schützenberger: encounter with Moreno",
    startPage: "89",
    items: [
      { t: "5.1  Psychogenealogy and the Genosociogram", p: "89" },
      { t: "Bibliographical references for Chapter 5", p: "96", ref: true },
    ],
  },
  {
    big: "06",
    tag: "Chapter 6",
    title: "The Continuity of Memory: from Semon’s theories to Moreno’s Approach and the Epistemology of Self Doubling",
    startPage: "97",
    items: [
      { t: "The secrets of engrams: from Semon to Lashley, a journey into neural memory", p: "97", indent: 1 },
      { t: "6.1  Richard Semon and the theory of the Mneme (1904)", p: "98" },
      { t: "6.2  Karl Lashley: the search for the engram and the principles of equipotentiality and mass action (1929–1950)", p: "99" },
      { t: "6.3  The engram in contemporary neuroscience: Tonegawa, Pignatelli, and Ryan", p: "101" },
      { t: "6.4  The engram as an interweaving of memories: a three-level taxonomy", p: "103" },
      { t: "6.5  The engram and the cultural conserve: the bridge between Semon and Moreno", p: "104" },
      { t: "6.6  Heidegger, Moreno, and authentic listening: the Logos as the foundation of the encounter", p: "105" },
      { t: "6.7  The founding roots and Self Doubling as an advanced method for the transformation of memory", p: "106" },
      { t: "6.8  The conditions of access to Self Doubling", p: "109" },
      { t: "6.9  Conclusions", p: "110" },
      { t: "Bibliographical references for Chapter 6", p: "112", ref: true },
    ],
  },
  {
    big: "07",
    tag: "Chapter 7",
    title: "Reshaping reality: the restructuring of space and time in transgenerational psychodrama",
    startPage: "116",
    items: [
      { t: "7.1  Logos, language, and the construction of reality", p: "117" },
      { t: "7.2  The Logos of the body: when the word falls silent, the body speaks", p: "123" },
      { t: "7.3  Psychodrama as an epistemology of meaning", p: "127" },
      { t: "7.4  The Genosociogram of the Word", p: "129" },
      { t: "7.5  Self Doubling as disclosure", p: "131" },
      { t: "7.6  Neurocognitive implications", p: "132" },
      { t: "7.7  Change as a restructuring of the inner field", p: "134" },
      { t: "Bibliographical references for Chapter 7", p: "136", ref: true },
    ],
  },
  {
    big: "08",
    tag: "Chapter 8",
    title: "From classical psychodramatic work to the possibility of Self Doubling",
    startPage: "139",
    items: [
      { t: "8.1  The preliminary work: psychodramatic exploration, roles, and memory", p: "139" },
      { t: "8.2  The genosociogram as a field for the emergence of memories", p: "142" },
      { t: "8.2.1  The Genosociogram of the Word: a lexical mapping of the family system", p: "143", indent: 1 },
      { t: "8.3  The wound of primary trust: the caregiver, the function of the Double, and the cognitive void", p: "145" },
      { t: "8.3.1  The Morenian identity matrix: undifferentiation and differentiation", p: "146", indent: 1 },
      { t: "8.3.2  Beyond undifferentiation: the cognitive void as an original concept", p: "147", indent: 1 },
      { t: "8.3.3  The body as the site of inscription of the cognitive void", p: "149", indent: 1 },
      { t: "8.4  When classical work meets a transformative limit", p: "150" },
      { t: "8.5  The moment of transition: intuiting the possibility of the internal/direct Double", p: "152" },
      { t: "8.5.1  The recognition by Monica Zuretti", p: "154", indent: 1 },
      { t: "8.6  Why Self Doubling cannot be applied without direct training", p: "156" },
      { t: "Bibliographical references for Chapter 8", p: "158", ref: true },
    ],
  },
  {
    big: "09",
    tag: "Chapter 9",
    title: "Self Doubling: methodological foundations, originality, and responsibility",
    startPage: "159",
    items: [
      { t: "9.1  Premise: Self Doubling in the path of the research", p: "159" },
      { t: "9.2  Dissociation, the synthesis of consciousness, and internal parts", p: "160" },
      { t: "9.3  The structural model of dissociation: ANP and EP", p: "161" },
      { t: "9.4  Classical psychodrama in the face of internal multiplicity", p: "162" },
      { t: "9.5  The Mosca Method: the dissociated part as witness-subject", p: "163" },
      { t: "9.6  Self Doubling as a direct encounter with one’s own Double and the witnessing function", p: "165" },
      { t: "9.7  The individual setting of Self Doubling", p: "167" },
      { t: "9.8  Comparative scheme: models, access to trauma, and the status of the internal part", p: "168" },
      { t: "9.9  Genealogy of the Double and epistemological clarification", p: "169" },
      { t: "9.9.1  Jacob Levy Moreno: the original matrix", p: "170", indent: 1 },
      { t: "9.9.2  Zerka Toeman Moreno: the Double, role reversal, and the cosmic dimension", p: "170", indent: 1 },
      { t: "9.9.3  Adam Blatner: the contemporary systematisation of the Double", p: "171", indent: 1 },
      { t: "9.9.4  The decolonial Doubles and the collective dimension of the Double", p: "172", indent: 1 },
      { t: "9.9.5  Giovanni Boria: the actor-self and bodily memories", p: "172", indent: 1 },
      { t: "9.9.6  Bessel van der Kolk: the body as the archive of trauma", p: "173", indent: 1 },
      { t: "9.9.7  Peter A. Levine: incomplete defensive response and somatic memory", p: "173", indent: 1 },
      { t: "9.9.8  Ivor Browne: trauma as unlived experience", p: "174", indent: 1 },
      { t: "9.9.9  E. J. Schreiber: Morenian mysticism and the suspended field", p: "175", indent: 1 },
      { t: "9.10  Self Doubling as a guided process: criteria, limits, and responsibility", p: "175" },
      { t: "9.10.1  The criterion of psychodramatic preparation", p: "175", indent: 1 },
      { t: "9.10.2  The criterion of space: scene, cognitive maps, and orientation", p: "176", indent: 1 },
      { t: "9.10.3  The criterion of the body and embodied perception", p: "177", indent: 1 },
      { t: "9.10.4  The criterion of resonance: the Double, mirror neurons, and the limit of external mediation", p: "177", indent: 1 },
      { t: "9.10.5  The criterion of time: duration, readiness, and the therapist’s temporal competence", p: "178", indent: 1 },
      { t: "9.10.6  Criteria of applicability", p: "179", indent: 1 },
      { t: "9.10.7  Limits and responsibility", p: "179", indent: 1 },
      { t: "9.11  The engrammatic network and regeneration", p: "180" },
      { t: "The engram: the origin of the concept and scientific caution", p: "180", indent: 1 },
      { t: "9.11.1  The engrammatic network", p: "181", indent: 1 },
      { t: "9.11.2  Engrammatic regeneration", p: "182", indent: 1 },
      { t: "9.12  Comparative synthesis: previous contributions and the specificity of Self Doubling", p: "183" },
      { t: "9.13  The originality of the Mosca Method: boundaries and specific formulations", p: "184" },
      { t: "9.14  Ethical, training, and transformative conditions for the use of Self Doubling", p: "190" },
      { t: "9.15  Concluding note", p: "193" },
      { t: "Bibliographical references for Chapter 9", p: "196", ref: true },
    ],
  },
  {
    big: "10",
    tag: "Chapter 10",
    title: "Methodological imprints in psychodrama: authors, works, and lines of development",
    startPage: "199",
    items: [
      { t: "10.1  Epistemological premise", p: "199" },
      { t: "10.2  Jacob Levy Moreno: action, spontaneity, and sociometry", p: "200" },
      { t: "10.3  Zerka Toeman Moreno: technical precision, surplus reality, and the cosmic dimension", p: "201" },
      { t: "10.4  Anne Ancelin Schützenberger: the genosociogram and transgenerational memory", p: "202" },
      { t: "10.5  Giovanni Boria: the Studio di Psicodramma and the founding of the Italian tradition", p: "203" },
      { t: "10.6  Paola de Leonardis: art, science, and the transformative functions of psychodrama", p: "204" },
      { t: "10.7  Monica Zuretti: Morenian fidelity, psychosociodrama, and the spiritual dimension of the scene", p: "205" },
      { t: "10.8  Marcia Karp: the director, the warm-up, and the structure of the session", p: "207" },
      { t: "10.9  Grete Leutz: theory, praxis, and the European tradition of psychodrama", p: "207" },
      { t: "10.10  Peter Felix Kellermann: therapeutic aspects, trauma, and integration", p: "208" },
      { t: "10.11  José Fonseca: contemporary psychodrama, internal psychodrama, and new theoretical developments", p: "209" },
      { t: "10.12  Débora Moghilevsky de Penna: fractal memory, transgenerationality, and scenic space", p: "209" },
      { t: "10.13  Synthesis: a living tradition, not a closed genealogy", p: "210" },
      { t: "Bibliographical references for Chapter 10", p: "212", ref: true },
    ],
  },
  {
    big: "✦",
    tag: "Conclusion",
    title: "The bridge towards the Truth that dwells within us",
    startPage: "214",
    items: [
      { t: "The act of trust towards oneself", p: "215" },
      { t: "Two hemispheres, one single being", p: "215" },
      { t: "What obscures the path", p: "216" },
      { t: "Spiritual beings rediscovered in matter", p: "217" },
      { t: "A bridge, not a destination", p: "218" },
      { t: "The Author", p: "220" },
      { t: "Chronological note on the genesis, priority, and traceability of the method", p: "225" },
    ],
  },
];

